import { Component, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Content } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

import { JobsProvider } from './../../providers/jobs/jobs';
import { AuthProvider } from './../../providers/auth/auth';
import { StaffProvider } from '../../providers/staff/staff';

import { CreateQuotePage } from './../create-quote/create-quote';

import { IJob, IStaff } from './../../interfaces/jobs';
import { IStaffType } from './../../interfaces/staff';
import { IAddress } from './../../interfaces/address';
import { IRecruiterUser } from '../../interfaces/users';

@IonicPage({
  name: 'create-job',
  segment: 'jobs/create-job'
})
@Component({
  selector: 'page-create-job',
  templateUrl: 'create-job.html'
})
export class CreateJobPage implements OnInit {
  @ViewChild('page') page: Content;
  @ViewChild('startDate') startDate;
  @ViewChild('endDate') endDate;
  title = 'Create a Job';
  fbUser: any;
  user: IRecruiterUser;
  jobForm: FormGroup;
  staffForm: FormGroup;
  staffList: Array<IStaff> = [];
  staffTypes: Array<IStaffType> = [];
  quantities = [];
  levels = [];
  today = moment().subtract(1, 'days');
  showStartDateCalendar = false;
  showEndDateCalendar = false;
  showDateError = false;

  constructor(
    public navCtrl: NavController,
    private jobsProvider: JobsProvider,
    private staffProvider: StaffProvider,
    private authProvider: AuthProvider,
    private formBuilder: FormBuilder
  ) {
    this.jobForm = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required])],
      startDate: ['', Validators.compose([Validators.required])],
      startTime: ['', Validators.compose([Validators.required])],
      endDate: ['', Validators.compose([Validators.required])],
      endTime: ['', Validators.compose([Validators.required])],
      comments: [''],
      addressLine1: ['', Validators.compose([Validators.required])],
      addressLine2: ['', Validators.compose([Validators.required])],
      city: ['', Validators.compose([Validators.required])],
      province: ['', Validators.compose([Validators.required])],
      postalCode: ['', Validators.compose([Validators.required])]
    });
    this.staffForm = this.formBuilder.group({
      staffType: ['', Validators.compose([Validators.required])],
      level: ['', Validators.compose([Validators.required])],
      quantity: ['', Validators.compose([Validators.required])]
    });

    for (let i = 1; i < 25; i++) {
      this.quantities.push(i);
    }

    for (let i = 1; i < 6; i++) {
      this.levels.push(i);
    }
  }
  ngOnInit() {
    this.authProvider.getFbUser().then(fbUser => {
      this.fbUser = fbUser;
      this.authProvider.getRecruiterUser(fbUser.uid).subscribe(usr => {
        this.user = usr;
        this.setUserdetails();
        return usr;
      });
    });
    this.loadStaffTypes();
  }

  ionViewDidLoad() {
    console.log(this.today);
    console.log('ionViewDidLoad CreateJobPage');
  }

  loadStaffTypes() {
    this.staffProvider.getStaffTypes().subscribe(staff => {
      console.log(staff);
      this.staffTypes = staff;
      return staff;
    });
  }

  setUserdetails() {
    this.jobForm.controls.addressLine1.setValue(this.user.address.line1);
    this.jobForm.controls.addressLine2.setValue(this.user.address.line2);
    this.jobForm.controls.city.setValue(this.user.address.city);
    this.jobForm.controls.province.setValue(this.user.address.province);
    this.jobForm.controls.postalCode.setValue(this.user.address.postalCode);
  }

  submit() {
    console.log('inside submit');
    console.log(this.jobForm.value);

    this.calculateStaff();

    const address: IAddress = {
      line1: this.jobForm.value.addressLine1,
      line2: this.jobForm.value.addressLine2,
      city: this.jobForm.value.city,
      province: this.jobForm.value.province,
      postalCode: this.jobForm.value.postalCode
    };

    console.log(address);

    const job: IJob = {
      name: this.jobForm.value.name,
      start: this.calculateStart(),
      end: this.calculateEnd(),
      address: address,
      staff: this.staffList,
      comments: this.jobForm.value.comments,
      createdBy: this.fbUser.uid,
      hours: this.calculateJobHours(),
      total: this.calculateTotal()
    };

    console.log(job);

    if (job.start > job.end ) {
      console.log('job start date is after job end');
      this.showDateError = true;
      this.page.scrollToTop();
    } else {
      this.showDateError = false;
      this.navCtrl.push(CreateQuotePage, {
        job: job,
        staffTypes: this.staffTypes
      });
    }

    // this.jobs.createJob(job);
  }

  addStaff() {
    const staffType = this.staffTypes.find(
      st => st.title === this.staffForm.value.staffType
    );

    const newStaff: IStaff = {
      staffType: staffType,
      level: this.staffForm.value.level,
      quantity: this.staffForm.value.quantity,
      staffRate: staffType.staffRate,
      recruiterRate: staffType.recruiterRate
    };

    newStaff.total = (newStaff.recruiterRate * this.calculateJobHours()) * newStaff.quantity;

    console.log(newStaff);
    this.staffList.push(newStaff);
    this.resetStaffForm();
  }

  calculateStaff() {
    this.staffList.forEach(staff => {
      staff.total = (staff.recruiterRate * this.calculateJobHours()) * staff.quantity;
    });
  }

  calculateStart() {
    const startDate = moment(this.jobForm.value.startDate, 'YYYYMMDD');
    let start = moment(
      `${startDate.format('YYYYMMDD')}T${this.jobForm.value.startTime}`,
      'YYYYMMDDHHmm'
    ).format();
    return start;
  }

  calculateEnd() {
    const endDate = moment(this.jobForm.value.endDate, 'YYYYMMDD');
    let end = moment(
      `${endDate.format('YYYYMMDD')}T${this.jobForm.value.endTime}`,
      'YYYYMMDDHHmm'
    ).format();
    return end;
  }

  calculateJobHours() {
    const startDate = moment(this.jobForm.value.startDate, 'YYYYMMDD');
    const endDate = moment(this.jobForm.value.endDate, 'YYYYMMDD');
    console.log(`startDate: ${startDate} - endDate: ${endDate}`);

    const startTime = moment(`${startDate.format('YYYYMMDD')}T${this.jobForm.value.startTime}`, 'YYYYMMDDHHmm');
    const endTime = moment(`${startDate.format('YYYYMMDD')}T${this.jobForm.value.endTime}`, 'YYYYMMDDHHmm');
    console.log(`startTime: ${startTime} - endTime: ${endTime}`);

    let hourDuration = moment.duration(endTime.diff(startTime));
    let dayDuration = moment.duration(endDate.diff(startDate));
    let hours = hourDuration.asHours();
    let days = dayDuration.asDays() + 1;

    if (days > 1) {
      hours = (hours * days);
      console.log(`Hours: ${hours}`); 
    } else {
      console.log(`Hours: ${hours}`); 
    }

    return Math.ceil(hours);
  }

  calculateTotal() {
    let total = 0;
    this.staffList.forEach(staff => {
      console.log(`calculate total: ${staff.total}`);
      total = total + staff.total;
    });
    return parseFloat(total.toFixed(2));
  }

  removeStaff(idx: number) {
    this.staffList.splice(idx, 1);
  }

  resetStaffForm() {
    this.staffForm.controls.staffType.setValue('');
    this.staffForm.controls.level.setValue('');
    this.staffForm.controls.quantity.setValue('');
  }

  // TODO: look into this
  calculateTime(offset: any) {
    let d = new Date();
    let nd = new Date(d.getTime() + 3600000 * offset);
    return nd.toISOString();
  }

  dateSelected(evt, element) {
    if (element === 'startDateCalendar') {
      this.jobForm.controls.startDate.setValue(this.formatDateString(evt));
      this.startDate.setFocus();
      this.showStartDateCalendar = false;
      this.showEndDateCalendar = false;
    } else {
      this.jobForm.controls.endDate.setValue(this.formatDateString(evt));
      this.endDate.setFocus();
      this.showEndDateCalendar = false;
      this.showEndDateCalendar = false;
    }
  }

  showCalendar(calendar) {
    if (calendar === 'startDateCalendar') {
      this.showStartDateCalendar = true;
      this.showEndDateCalendar = false;
    } else {
      this.showEndDateCalendar = true;
      this.showStartDateCalendar = false;
    }
  }

  closeCalendar(calendar) {
    if (calendar === 'startDateCalendar') {
      this.showStartDateCalendar = false;
    } else {
      this.showEndDateCalendar = false;
    }
  }

  formatDateString(date) {
    console.log(date);
    const formattedDate = moment(date).format('YYYY/MM/DD');
    console.log(`formattedDate: ${formattedDate}`);
    console.log(moment(`${formattedDate}`));
    return formattedDate;
  }
}



// WEBPACK FOOTER //
// ./src/pages/create-job/create-job.ts